module.exports = {
	"sprite-horizontal.png": "sprite-horizontal-59104f599c.png",
	"sprite-horizontal@2x.png": "sprite-horizontal@2x-6431f32557.png",
	"sprite-main.png": "sprite-main-1a14b1eb81.png",
	"sprite-main@2x.png": "sprite-main@2x-db41995d4a.png"
};


//////////////////
// WEBPACK FOOTER
// ./public/build/img/rev-manifest.json
// module id = wGR8
// module chunks = 1